module.exports = __webpack_public_path__ + "img/case_8.6ae2ad67.svg";